import { MemoryRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";

import Routes from "app/routes";
import AppStateProvider from "./providers/AppStateProvider";
import ToastContainer from "./components/ToastContainer";
import DevModeWidget from "./components/DevModeWidget";
import QueryProvider from "./providers/QueryProvider";
import ErrorWidget from "./components/ErrorWidget";

export default function App() {
  return (
    <Sentry.ErrorBoundary fallback={ErrorWidget}>
      <AppStateProvider>
        <MemoryRouter>
          <ToastContainer />

          <QueryProvider>
            {process.env.NODE_ENV === "development" && <DevModeWidget />}

            <Routes />
          </QueryProvider>
        </MemoryRouter>
      </AppStateProvider>
    </Sentry.ErrorBoundary>
  );
}
